/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsArrowsRepeatV: {
  name: 'arrows-repeat-v';
  data: string;
} = {
  name: 'arrows-repeat-v',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><g clip-path="url(#a)"><path fill-rule="evenodd" clip-rule="evenodd" d="M13.354.646a.5.5 0 0 0-.708 0l-2 2a.5.5 0 0 0 .708.708L12.5 2.207V14a.5.5 0 0 1-.5.5H9a.5.5 0 0 0 0 1h3a1.5 1.5 0 0 0 1.5-1.5V2.207l1.146 1.147a.5.5 0 0 0 .708-.708l-2-2ZM4 .5A1.5 1.5 0 0 0 2.5 2v11.793l-1.146-1.147a.5.5 0 0 0-.708.708l2 2a.5.5 0 0 0 .708 0l2-2a.5.5 0 0 0-.708-.708L3.5 13.793V2a.5.5 0 0 1 .5-.5h3a.5.5 0 1 0 0-1H4Z" fill="currentColor"/></g><defs><clipPath id="a"><path fill="currentColor" d="M0 0h16v16H0z"/></clipPath></defs></svg>`,
};
